import { Card, Col, Divider, List, Modal, Row } from 'antd';
import React, { memo } from 'react';
import { useQuery } from 'react-query';

import {
  AssetCatalogResponse,
  getAssetCatalogByKeyword,
} from '../../services/assetconfig';
import { CATALOG_IMG_URL } from '../../utils/config';
import { toCurrency } from '../../utils/utils';

type AssetCatalogItemDetailsModalProps = {
  visible: boolean;
  item?: AssetCatalogResponse;
  cataloglabel?: string;
  onCancel: () => void;
  currcode?: string;
};

const AssetCatalogItemDetailsModal = (
  props: AssetCatalogItemDetailsModalProps
) => {
  const { visible, onCancel, cataloglabel, currcode } = props;

  const { data: assetsCatalog } = useQuery(
    ['getAssetCatalogByKeyword', { cataloglabel }],
    () =>
      getAssetCatalogByKeyword({
        keyword: cataloglabel,
        filters: '',
        mcid: '',
        mgid: '',
        networkcode: '',
        tpidbroker: '',
        currcode: currcode,
      } as any).then((res) => res.list[0] || []),
    {
      enabled: Boolean(cataloglabel),
      staleTime: 30 * 1000,
    }
  );
  let item = props.item || assetsCatalog;

  const imageSrc = CATALOG_IMG_URL + item?.assetpictureurl;

  return item ? (
    <Modal
      open={visible}
      title={item.assetlabel}
      footer={null}
      onCancel={onCancel}
      width="700px"
    >
      <Card>
        <Row>
          <Col span={12}>
            <img alt="example" style={{ width: '300px' }} src={imageSrc} />
          </Col>
          <Col>
            <Row>
              <Col style={{ color: 'blue' }}>ID:</Col>{' '}
              <Col>{item.catalogid}</Col>
            </Row>
            <Row>
              <Col style={{ color: 'blue' }}>Model:</Col>{' '}
              <Col>{item.assetmodellabel}</Col>
            </Row>
            <Row>
              <Col style={{ color: 'blue' }}>Label:</Col>{' '}
              <Col>{item.assetlabel}</Col>
            </Row>
            <Row>
              <Col style={{ color: 'blue' }}>Description:</Col>{' '}
              <Col>{item.assetdescription}</Col>
            </Row>
            <Row>
              <Col style={{ color: 'blue' }}>Contructor:</Col>{' '}
              <Col>{item.assetconstructor}</Col>
            </Row>
            <Row>
              <Col style={{ color: 'blue' }}>Ref#:</Col>{' '}
              <Col>{item.assetconstructorreference}</Col>
            </Row>
            <Row>
              <Col style={{ color: 'blue' }}>Variant:</Col>{' '}
              <Col>{item.assetvariant}</Col>
            </Row>
            <Row>
              <Col style={{ color: 'blue' }}>Net origine:</Col>{' '}
              <Col>{item.assetnetamountorigine}</Col>
            </Row>
            <Row>
              <Col style={{ color: 'blue' }}>Net après discount:</Col>{' '}
              <Col>{item.assetnetamount}</Col>
            </Row>
            <Row>
              <Col style={{ color: 'blue' }}>Total Origine:</Col>{' '}
              <Col>{item.assetgrossamount}</Col>
            </Row>
            <Row>
              <Col style={{ color: 'blue' }}>Total après Discount:</Col>{' '}
              <Col>{item.assetgrossamountorigine}</Col>
            </Row>
          </Col>
        </Row>

        <Divider orientation="left" />
        <List
          size="small"
          header={
            <div style={{ color: 'blue' }}>
              This price includes : (Original Amount / Discount% / Net Amount)
            </div>
          }
          bordered
          dataSource={item.assetCatalogComponents}
          renderItem={(component) => (
            <List.Item>
              <div>{component.compdescription}</div>
              <del>
                {toCurrency(component.comporiginalnetamount, currcode ?? localStorage.getItem('currcode') ?? '')}
              </del>
              <div>{component.compdiscountrate}%</div>
              <div>
                {toCurrency(component.compnetamount, currcode ?? localStorage.getItem('currcode') ?? '')}
              </div>
            </List.Item>
          )}
        />
      </Card>
    </Modal>
  ) : null;
};

export default memo(AssetCatalogItemDetailsModal);
